module.exports = __webpack_public_path__ + "img/jambyl3.7231c15f.jpg";